import { FETCH_PROTOCOL_DEVIATIONS } from '../../actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_PROTOCOL_DEVIATIONS);
export default addReducer;
